// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__3OdHQ","flexMain":"App_flexMain__10zrU"};